import { IEnterpriseMarketPricingsRequest } from '../../interfaces/enterprise-market-pricings.interface'

export class GetEnterpriseMarketPricings {
  static readonly type = '[EnterpriseMarketPricings] Get Enterprise MarketPricings'
  constructor(public payload: IEnterpriseMarketPricingsRequest) {}
}
